import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from "react-redux";
// import Profile from "../../Assets/profile.png";
import { useDispatch } from "react-redux";
import { Api, BaseUrl, ImagePath } from '../Config/Api';
import { COLOR, FONT, IMAGE } from '../Config/Color';
import Cropper from "react-easy-crop";
import axios from "axios";
import { toast } from 'react-toastify';
import { getEmployeeProfile } from '../../redux/actions/employeeActions';
import { getLeavs } from '../../helpers/frontend';

const getCroppedImg = async (imageSrc, crop) => {
    const image = new Image();
    image.src = imageSrc;
    await new Promise((resolve) => (image.onload = resolve));

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    canvas.width = crop.width;
    canvas.height = crop.height;

    ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
    );

    return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            resolve(blob);
        }, "image/jpeg");
    });
};
function ProfileDetailsCard({ ChildComponent, style, position, attendanceData, formData }) {
    const employeeId = sessionStorage.getItem("employeeId");
    const token = sessionStorage.getItem("authToken");
    const [selectedImage, setSelectedImage] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [filteredLeaveData, setFilteredLeaveData] = useState([]);
    const profileData = useSelector((state) => state.employeeData?.profile)
    const dispatch = useDispatch();
    const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {}
    const [previewImage, setPreviewImage] = useState();
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const handleImageSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(file);
            setPreviewImage(URL.createObjectURL(file));
        }
    };

    const handleImageUpload = async () => {
        try {
            if (!(selectedImage instanceof File)) {
                throw new Error("Selected image is not a valid File object.");
            }
            const reader = new FileReader();
            reader.onloadend = async () => {
                // setLoading(true);
                const imageDataUrl = reader.result;
                const img = new Image();
                img.src = imageDataUrl;
                img.onload = async () => {
                    const croppedImageBlob = await getCroppedImg(
                        imageDataUrl,
                        croppedAreaPixels
                    );

                    if (!croppedImageBlob) {
                        return;
                    }
                    const croppedImageFile = new File(
                        [croppedImageBlob],
                        "cropped-image.jpg",
                        {
                            type: "image/jpeg",
                        }
                    );

                    const formDataToSend = new FormData();
                    formDataToSend.append("employee_id", employeeId);
                    formDataToSend.append("image", croppedImageFile);

                    const response = await axios.post(
                        `${BaseUrl}${Api.UPLOAD_PROFILE_IMAGE}`,
                        formDataToSend,
                        {
                            headers: {
                                "X-Company-ID": userDetails.company_id,
                                "Content-Type": "multipart/form-data",
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );

                    // Handle the API response
                    if (response?.data?.authenticated === false) {
                        toast.error(response?.data?.mssg[0]);
                        // logout();
                    } else if (response?.data?.valid === false) {
                        toast.error(response?.data?.mssg[0]);
                        // setLoading(false);
                    } else if (response?.data?.success === true) {
                        toast.success("Image added successfully");
                        setIsDialogOpen(false);
                        setSelectedImage(null);
                        dispatch(getEmployeeProfile(employeeId))
                    } else {
                        toast.error(response?.data?.mssg);
                    }
                };

                img.onerror = (error) => {
                    console.error("Image load error:", error);
                    alert("Failed to load the image.");
                };
            };

            reader.readAsDataURL(selectedImage);
        } catch (error) {
            console.error("API call failed:", error);
            alert("An error occurred. Please try again.");
        }
    };
    const onCropComplete = useCallback((_, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const getTotalLate = (data) => {
        const totalLate = data.filter(
            (entry) => entry.type == "Late"
        ).length;
        return totalLate;
    };
    const getOntime = (data) => {
        const LATE_THRESHOLD = "09:00";
        const totalPresent = data.filter(
            (entry) => entry.attendance_status == "Present" || entry.type == "On Time"
        ).length;
        return totalPresent;
    };



    useEffect(() => {
        if (ChildComponent) {
            const filterLeaveData = () => {
                if (formData.statusType === "ALL Data") {
                    const allData = attendanceData?.filter((leave) => {
                        return (
                            leave.year === formData.leaveYear &&
                            leave.month === formData.leaveMonth
                        );
                    });

                    setFilteredLeaveData(allData);
                    // getCountAttendanceDarta(allData);
                } else {
                    const filteredData = attendanceData?.filter((leave) => {
                        return (
                            leave.year === formData.leaveYear &&
                            leave.month === formData.leaveMonth &&
                            // leave.attendance_status === formData.statusType
                            (leave.attendance_status === formData.statusType ||
                                leave.work_status == formData.statusType)
                        );
                    });
                    setFilteredLeaveData(filteredData);
                    // getCountAttendanceDarta(filteredData);
                }
            };
            filterLeaveData();
        }
    }, [
        formData?.leaveYear,
        formData?.leaveMonth,
        formData?.statusType,
        attendanceData,
    ]);


    // //console.log("filteredLeaveData" ,filteredLeaveData);
    const path = window.location?.pathname == "/employee/"
    return (
        <React.Fragment>
            <div style={style} className={`${position ? position : "absolute"} top-[50px] left-1/2 transform -translate-x-1/2 w-[95%] bg-white shadow-sm rounded-lg  p-6`}>
                <div className="flex items-start space-x-6">
                    <div className={`relative w-[150px] h-[150px] ${!path ? " pt-3 pl-4":""}`}>
                        {profileData?.image == null ? (
                            <div className="w-full h-full flex justify-center items-center bg-blue-700 text-white font-bold text-2xl rounded-md">
                                {profileData?.name?.charAt(0).toUpperCase()}
                            </div>
                        ) : (
                            <img
                                src={profileData?.image ? profileData?.image : "/assets/img/user.png"}
                                alt="User"
                                className={`${path ? "w-full h-full" : "w-14  h-14"}  border  rounded-md object-cover border`}
                            />
                        )}

                        {/* Edit Button at Bottom-Right */}
                        {
                            window.location?.pathname == "/employee/" &&
                            <button
                                className="absolute bottom-[-5px] right-[-10px] bg-white p-1 rounded-full shadow transition flex items-center justify-center"
                                onClick={() => console.log("Edit Image Clicked")}
                            >
                                <img
                                    src={"/assets/Assets/NewImage/pen.png"}
                                    alt="User"
                                    style={{ width: "15px", height: "15px" }}
                                    onClick={() => {
                                        setIsDialogOpen(true);
                                    }}
                                />
                            </button>
                        }
                    </div>

                    <div className="flex flex-col mt-2">
                        <h2
                            style={{
                                color: COLOR?.BLACK,
                                fontSize: "20px",
                                fontWeight: "600",
                                fontFamily: FONT?.INTER,
                                lineHeight: "32px",
                            }}
                        >
                            {profileData?.name}
                        </h2>
                        <h3
                            style={{
                                color: COLOR?.BLACK1,
                                fontSize: "15px",
                                fontWeight: "500",
                                lineHeight: "22px",
                                fontFamily: FONT?.INTER,
                            }}
                        >
                            {profileData?.designation}
                        </h3>
                        <h3
                            className=" mt-1"
                            style={{
                                color: COLOR?.GRAY4,
                                fontSize: "15px",
                                fontWeight: "400",
                                lineHeight: "22px",
                                fontFamily: FONT?.INTER,
                            }}
                        >
                            I am a professional {profileData?.designation}
                        </h3>

                        <div className="flex flex-wrap mt-4 gap-3">
                            <div className="flex items-center px-3 py-1 border border-dashed rounded-lg text-gray-700 space-x-2">
                                <img src={IMAGE.CONTACT} className="w-4 h-4" alt="icon" />
                                <span
                                    style={{
                                        fontSize: "14px",
                                        fontFamily: FONT.INTER,
                                        fontWeight: "500",
                                        lineHeight: "22px",
                                        color: COLOR.GRAY4,
                                    }}
                                >
                                    {profileData?.employee_code}
                                </span>
                            </div>
                            <div className="flex items-center px-3 py-1 border border-dashed rounded-lg text-gray-700 space-x-2">
                                <img src={"/assets/Assets/NewImage/phone.png"} className="w-4 h-4" alt="icon" />
                                <span
                                    style={{
                                        fontSize: "14px",
                                        fontFamily: FONT.INTER,
                                        fontWeight: "500",
                                        lineHeight: "22px",

                                        color: COLOR.GRAY4,
                                    }}
                                >
                                    {profileData?.mobile}
                                </span>
                            </div>
                            <div className="flex items-center px-3 py-1 border border-dashed rounded-lg text-gray-700 space-x-2">
                                <img src={IMAGE.EMAIL} className="w-4 h-4" alt="icon" />
                                <span
                                    style={{
                                        fontSize: "14px",
                                        fontFamily: FONT.INTER,
                                        fontWeight: "500",
                                        lineHeight: "22px",

                                        color: COLOR.GRAY4,
                                    }}
                                >
                                    {profileData?.email}
                                </span>
                            </div>
                            <div className="flex items-center px-3 py-1 border border-dashed rounded-lg text-gray-700 space-x-2">
                                <img src={IMAGE.LOCATION} className="w-4 h-4" alt="icon" />
                                <span
                                    style={{
                                        fontSize: "14px",
                                        fontFamily: FONT.INTER,
                                        fontWeight: "500",
                                        lineHeight: "22px",

                                        color: COLOR.GRAY4,
                                    }}
                                >
                                    {profileData?.location}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    ChildComponent &&
                    <div className="leave-summary-container flex justify-between items-center mt-2 px-4">
                        <div className="flex flex-wrap gap-4">
                            <div className="leave-card annual-leaves">
                                <span
                                    style={{
                                        fontFamily: FONT.INTER,
                                        fontSize: "20px",
                                        lineHeight: "28px",
                                        color: "#FFCC00",
                                        fontWeight: "600",
                                    }}
                                >
                                    {getTotalLate(filteredLeaveData)}
                                </span>
                                <span
                                    style={{
                                        fontFamily: FONT.INTER,
                                        fontSize: "14px",
                                        lineHeight: "22px",
                                        color: COLOR.GRAY4,
                                        fontWeight: "500",
                                    }}
                                >
                                    Total Late
                                </span>
                            </div>

                            <div className="leave-card leave-collected">
                                <span
                                    style={{
                                        fontFamily: FONT.INTER,
                                        fontSize: "20px",
                                        lineHeight: "28px",
                                        color: "#34C759",
                                        fontWeight: "600",
                                    }}
                                >
                                    {getOntime(filteredLeaveData)}
                                </span>
                                <span
                                    style={{
                                        fontFamily: FONT.INTER,
                                        fontSize: "14px",
                                        lineHeight: "22px",
                                        color: COLOR.GRAY4,
                                        fontWeight: "500",
                                    }}
                                >
                                    Present Days
                                </span>
                            </div>

                            <div className="leave-card paid-leaves">
                                <span
                                    style={{
                                        fontFamily: FONT.INTER,
                                        fontSize: "20px",
                                        lineHeight: "28px",
                                        color: "#AF52DE",
                                        fontWeight: "600",
                                    }}
                                >
                                    {getLeavs(filteredLeaveData)}
                                </span>
                                <span
                                    style={{
                                        fontFamily: FONT.INTER,
                                        fontSize: "14px",
                                        lineHeight: "22px",
                                        color: COLOR.GRAY4,
                                        fontWeight: "500",
                                    }}
                                >
                                    Total Leaves
                                </span>
                            </div>
                        </div>
                    </div>
                }
            </div>

            {isDialogOpen && (
                <div
                    className="dialog-backdrop"
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        zIndex: 1000,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                    }}
                >
                    <div
                        className="dialog"
                        style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 1001,
                            backgroundColor: "white",
                            padding: "20px",
                            borderRadius: "8px",
                        }}
                    >
                        <h2 style={{ marginBottom: 30 }}>Update Profile Image</h2>
                        <input type="file" accept="image/*" onChange={handleImageSelect} />
                        {selectedImage && (
                            <div
                                style={{
                                    position: "relative",
                                    width: "100%",
                                    height: 200,
                                    zIndex: 1002,
                                }}
                            >
                                <Cropper
                                    image={previewImage}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={1}
                                    onCropChange={setCrop}
                                    onZoomChange={setZoom}
                                    onCropComplete={onCropComplete}
                                />
                            </div>
                        )}
                        <div className="dialog-buttons">
                            <button className="confirm-btn" onClick={handleImageUpload}>
                                Submit Image
                            </button>
                            <button
                                className="cancel-btn"
                                onClick={() => setIsDialogOpen(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    )
}

export default ProfileDetailsCard
